import classNames from "classnames";

const Skeleton = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={classNames(
        "animate-pulse rounded-md bg-main/10",
        className
      )}
      {...props}
    />
  );
};

export { Skeleton };
